import { Input } from "antd"
import styled from "styled-components"

export const FaxPageStyle = styled.div`
  width: 100%;
  height: 100%;
  padding: 24px;
  border-radius: 8px;
  background: ${(props) => props.theme.colordwhitedark};
  @media (min-width: 0px) and (max-width: 820px) {
    padding: 15px;
  }
  .refresh-icon {
    color: ${(props) => props.theme.primary};
    svg {
      width: 14px;
      height: 14px;
    }
  }
  @media (min-width: 0px) and (max-width: 820px) {
    .mobile-pagination {
      width: 100%;
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
      padding: 10px;
      background: ${(props) => props.theme.colordwhitedark};
      border-top: 1px solid ${(props) => props.theme.colorbluegreylight};
      .ant-pagination {
        width: 100%;
        color: ${(props) => props.theme.textcolordblack};
        .ant-pagination-item,
        .ant-pagination-next,
        .ant-pagination-prev,
        .ant-pagination-jump-next,
        .ant-pagination-jump-prev {
          font-size: 14px;
          color: ${(props) => props.theme.colorlightblack};
          border: 1px solid ${(props) => props.theme.colorbluegreylight};
          border-radius: 4px;
          .ant-pagination-item-link,
          .ant-pagination-item-ellipsis {
            color: ${(props) => props.theme.colorlightblack};
          }
          &.ant-pagination-item-active {
            border-color: ${(props) => props.theme.primary};
            background-color: transparent;
            margin: 0 5px;
          }
          &.ant-pagination-disabled {
            opacity: 0.5;
          }
        }
        .ant-pagination-jump-next,
        .ant-pagination-jump-prev{
          margin: 0 4px;
        } 
        .ant-pagination-options {
          display: block;
          margin-left: auto;
        }
        .ant-pagination-total-text {
          order: 5;
          margin-left: 10px;
        }
        .ant-pagination-item {
          &:not(.ant-pagination-item-active) {
            display: none;
          }
        }
      }
    }
  }
`;
export const FaxPageHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  @media (min-width: 0px) and (max-width: 820px) {
    position: fixed;
    left: 0;
    right: 0;
    top: 109px;
    z-index: 9;
    padding: 10px 15px;
    background: ${(props) => props.theme.colordwhitedark}; 
    border-bottom: 1px solid ${(props) => props.theme.colorbluegreylight};
  }
  h5 {
    font-size: 16px;
    margin: 0;
  }
  .refresh-icon {
    padding-left: 12px;
    svg {
      width: 16px;
      height: 16px;
    }
  }
  .ant-checkbox-wrapper {
    margin-left: 10px;
    align-items: center;
  }
`;
export const HeaderActions = styled.div`
  margin-left: auto;
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  position: relative;
  .filter-icon {
    width: 38px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 36px;
    color: ${(props) => props.theme.primary};
    cursor: pointer;
    display: none;
    @media (max-width: 1199px) {
      display: flex;
    }
  }
  .searchbar-wrapper {
    width: 38px;
    height: 38px;
    position: relative;
  }
`;
export const Search = styled(Input)<{ search?: string }>`
  position: absolute !important;
  right: 0;
  &.ant-input-affix-wrapper {
    background: ${(props) => props.theme.colordwhitedark};
    width: ${(props) => (props.search ? "350px" : "38px")};
    position: relative;
    overflow: hidden;
  }
  .ant-input-prefix {
    margin-right: 10px;
    padding-right: 10px;
    border-right: 1px solid ${(props) => props.theme.colorbluegreylight};
    pointer-events: none;
    position: relative;
    .anticon-search {
      font-size: 20px;
      color: ${(props) => props.theme.textcolordarkgrey};
    }
  }
  &.ant-input-affix-wrapper-focused {
    width: 350px;
    box-shadow: none;
    @media (max-width: 820px){
      width: 250px;
    }
  }
  .ant-input {
    color: ${(props) => props.theme.textcolordblack};
    background-color: transparent;
    &::placeholder {
      color: ${(props) => props.theme.textcolordarkgrey};
      opacity: 1;
    }
    &:-ms-input-placeholder {
      color: ${(props) => props.theme.textcolordarkgrey};
      opacity: 1;
    }
    &::-ms-input-placeholder {
      color: ${(props) => props.theme.textcolordarkgrey};
      opacity: 1;
    }
  }
`;
